module.exports = __webpack_public_path__ + "static/media/pin.fc31ffb5.svg";